import { defineStore } from 'pinia'
import { fetchJson } from '~/composables/request'
import { useGlobalStore } from '#imports'
// import FakeData from '~/pages/fake.js'
interface recommendsState {
  recommendData: Array<any>
}
export const useRecommendsStore = defineStore('recommendsStore', {
  state: (): recommendsState => {
    return {
      recommendData: []
    }
  },
  actions: {
    async getData() {
      const { jsonApi, tenantId,webSiteId } = useGlobalStore()
      try {
        const data = await fetchJson(`${jsonApi}/pages/${tenantId}/${webSiteId}/recommend.json`)
        this.recommendData = data == '[]' ? [] : data
        // console.log(data,'recommendData');
      } catch (error) {
        console.log(error);
      }
    }
  }
  // 开始数据持久化
  // persist: process.client && {
  //   key: 'searchData',
  //   storage: process.client && window.localStorage
  // }
})
